<template>
  <v-container v-editable="blok" class="mt-0 mb-5 py-0">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="6" md="6" class=" text-right">
          <v-sheet class="banner-container" :style="`background-image: url('${blok.image}');`" tile height="400">
        </v-sheet>
      </v-col>
      <v-col cols="12" sm="6" md="6" class=" text-left">
          <h2>{{blok.title}}</h2>
          <p>{{blok.description}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["blok"]
};
</script>

<style lang="scss" scoped>
@import "./ImageText.scss";
</style>